export default __webpack_public_path__ + "static/media/spainFlag.c7cd9a86.png";